export default "__VITE_ASSET__bgL6TTGq__"